import { useEffect, useState, useRef } from 'react';
import {
    Modal,
    Button,
    Form,
    Row,
    Col
} from 'react-bootstrap';
import './createCareerGuidanceSession.css';

const CreateCareerGuidanceSession = ({
    show,
    handleClose,
    handleSave,
    editMode,
    session
}) => {

    const [formData, setFormData] = useState({
        headline: '',
        descriptionText: '',
        image: null,
        imageUrl: '',
        sessionType: '',
        bookingType: 'SLOT_BASED',
        price: '',
        currency: 'INR'
    });

    const imageInputRef = useRef(null);



    useEffect(() => {

        if (show && editMode && session) {

            setFormData({
                headline: session.headline || '',
                descriptionText: session.descriptionText || '',
                image: null,
                imageUrl: session.imageUrl || '',
                sessionType: session.sessionType || '',
                price: session.price || '',
                currency: session.currency || 'INR'
            });

        }

        if (show && !editMode) {

            setFormData({
                headline: '',
                descriptionText: '',
                image: null,
                imageUrl: '',
                sessionType: '',
                price: '',
                currency: 'INR'
            });

        }

    }, [show, editMode, session]);

    const handleChange = (e) => {

        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

    };

    const handleImageChange = (e) => {

        const file = e.target.files?.[0];

        if (!file) {
            return;
        }

        setFormData(prev => ({
            ...prev,
            image: file
        }));

    };


    const onSave = () => {

        handleSave({
            ...formData,
            id: session?.id
        });

    };

    return (

        <Modal
            show={show}
            onHide={handleClose}
            centered
            size="lg"
            dialogClassName="create-career-guidance-modal"
        >

            <Modal.Header closeButton>

                <Modal.Title>
                    {editMode
                        ? 'Edit Career Guidance Session'
                        : 'Create Career Guidance Session'}
                </Modal.Title>

            </Modal.Header>

            <Modal.Body>

                <Form>

                    {/* Headline */}

                    <Form.Group className="mb-3">

                        <Form.Label>
                            Headline
                        </Form.Label>

                        <Form.Control
                            type="text"
                            name="headline"
                            value={formData.headline}
                            onChange={handleChange}
                            placeholder="Enter Headline"
                            disabled={editMode}
                        />

                    </Form.Group>


                    {/* Description */}

                    <Form.Group className="mb-3">

                        <Form.Label>
                            Description
                        </Form.Label>

                        <Form.Control
                            as="textarea"
                            rows={3}
                            name="descriptionText"
                            value={formData.descriptionText}
                            onChange={handleChange}
                            placeholder="Enter Description"
                        />

                    </Form.Group>


                    <Form.Group className="mb-3">

                        <Form.Label>
                            Upload Image
                        </Form.Label>

                        <div className="image-upload-wrapper">

                            <Form.Control
                                ref={imageInputRef}
                                type="file"
                                accept="image/*"
                                onChange={handleImageChange}
                            />

                            {/* Existing image while editing */}
                            {editMode && formData.imageUrl && !formData.image && (
                                <div className="uploaded-image-container">

                                    <div className="uploaded-image-file">

                                        <div className="uploaded-image-icon">
                                            🖼️
                                        </div>

                                        <div className="uploaded-image-file-info">

                                            <span className="uploaded-image-label">
                                                Current Image
                                            </span>

                                            <span className="uploaded-image-file-name">
                                                {formData.imageUrl.split('/').pop()}
                                            </span>

                                        </div>

                                    </div>

                                </div>
                            )}

                            {/* Newly selected image */}
                            {formData.image && (
                                <div className="uploaded-image-container">

                                    <div className="uploaded-image-file">

                                        <div className="uploaded-image-icon">
                                            🖼️
                                        </div>

                                        <div className="uploaded-image-file-info">

                                            <span className="uploaded-image-label">
                                                New Image
                                            </span>

                                            <span className="uploaded-image-file-name">
                                                {formData.image.name}
                                            </span>

                                        </div>

                                    </div>

                                </div>
                            )}

                        </div>

                    </Form.Group>



                    {/* Session Type + Price */}

                    <Row>

                        <Col md={12}>

                            <Form.Group className="mb-3">

                                <Form.Label>
                                    Session Type
                                </Form.Label>

                                <Form.Select
                                    name="sessionType"
                                    value={formData.sessionType}
                                    onChange={handleChange}
                                >

                                    <option value="">
                                        Select Session Type
                                    </option>

                                    <option value="GROUP">
                                        Group
                                    </option>

                                    <option value="INDIVIDUAL">
                                        Individual
                                    </option>

                                </Form.Select>

                            </Form.Group>

                        </Col>
                        <Col md={12}>

                            <Form.Group className="mb-3">

                                <Form.Label>
                                    Booking Type
                                </Form.Label>

                                <Form.Select
                                    name="bookingType"
                                    value={formData.bookingType}
                                    onChange={handleChange}
                                >

                                    <option value="SLOT_BASED">
                                        Slot Based
                                    </option>

                                    <option value="DIRECT_BOOKING">
                                        Direct Booking
                                    </option>

                                </Form.Select>

                            </Form.Group>
                        
                        </Col>


                        <Col md={12}>

                            <Form.Group className="mb-3">

                                <Form.Label>
                                    Price
                                </Form.Label>

                                <Form.Control
                                    type="number"
                                    name="price"
                                    value={formData.price}
                                    onChange={handleChange}
                                    placeholder="Enter Price"
                                />

                            </Form.Group>

                        </Col>

                    </Row>


                    {/* Currency */}

                    <Row>

                        <Col md={12}>

                            <Form.Group className="mb-3">

                                <Form.Label>
                                    Currency
                                </Form.Label>

                                <Form.Select
                                    name="currency"
                                    value={formData.currency}
                                    onChange={handleChange}
                                >

                                    <option value="INR">
                                        INR
                                    </option>

                                </Form.Select>

                            </Form.Group>

                        </Col>

                    </Row>

                </Form>

            </Modal.Body>


            <Modal.Footer>

                <Button
                    variant="secondary"
                    onClick={handleClose}
                >
                    Cancel
                </Button>

                <Button
                    variant="primary"
                    onClick={onSave}
                >
                    {editMode ? 'Update' : 'Save'}
                </Button>

            </Modal.Footer>

        </Modal>

    );
};

export default CreateCareerGuidanceSession;